<template>

    <div>
        <div v-if="avatarsStackedLimited && avatarsStackedLimited.length > 0" class="avatars-group stacked">
            <div v-for="(avatar,index) in avatarsStackedLimited" :key="index"
                 class="avatars-group__item">
                <profile-avatar size="35px" :avatar="avatar" slot="activator"></profile-avatar>
            </div>
            <div class="avatars-group__item more">



                <v-dialog
                        v-model="dialog"
                        width="500"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-avatar v-on="on" color="black" size="37px">
                            <v-icon color="white">
                                mdi-dots-horizontal
                            </v-icon>
                        </v-avatar>
                    </template>

                    <v-card>
                        <v-card-text>

                            <v-list subheader>
                                <v-subheader>Hanno votato:</v-subheader>

                                <v-list-item
                                        v-for="(avatar,i) in avatarsSorted"
                                        :key="i"
                                >
                                    <v-list-item-avatar>
                                        <profile-avatar :avatar="avatar" custom-class="bordered small"
                                                        size="32px"></profile-avatar>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title v-text="avatar.name"></v-list-item-title>
                                    </v-list-item-content>

                                </v-list-item>
                            </v-list>

                        </v-card-text>
                    </v-card>
                </v-dialog>

            </div>
        </div>
        <span v-else class="pl-4">Nessuna votazione</span>
    </div>

</template>

<script>
    import ProfileAvatar from './avatarProfile';

    export default {
        name: 'avatarList',
        components: {
            ProfileAvatar
        },
        props: {
            avatars: {
                type: Array | Object,
                default: []
            }
            /*{
                name: 'John Smitt',
                img: null
            }*/
        },
        data() {
            return {
                dialog:false,
                darkMode: true,
                menuMaxHeight: `${(60 * 5) + 4}px`,
                presence: false,
                stackedLimit: 5,
                stackedMenu: false
            }
        },

        computed: {
            avatarsSorted() {
                let a = this.avatars.slice(); // fix per infinito loop

                return (this.avatars && this.avatars.length > 0)
                    ? a.sort((a, b) => a.name.localeCompare(b.name))
                    : null
            },
            avatarsStackedLimited() {
                return (this.avatarsSorted && this.avatarsSorted.length > 0)
                    ? this.avatarsSorted.slice(0, this.stackedLimit)
                    : null
            }
        },

        methods: {
            GetColour(name) {
                let hash = 0;
                if (name.length === 0) return hash
                for (let i = 0; i < name.length; i++) {
                    hash = name.charCodeAt(i) + ((hash << 5) - hash)
                    hash = hash & hash
                }
                let color = '#'
                for (let i = 0; i < 3; i++) {
                    let value = (hash >> (i * 8)) & 255
                    color += ('00' + value.toString(16)).substr(-2)
                }
                return color
            }
        }
    }
</script>

<style scoped>

    .avatars-group.stacked {
        display: flex;
        flex-direction: row;
        direction: ltr;
        max-width: 100%;
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;
        justify-content: center;
        padding: 10px;
    }

    .avatars-group.stacked > * {
        margin-right: -8px;
    }

    /*.avatars-group.stacked > *:last-of-type {
        padding-right: 16px;
    }*/

    .avatars-group__item {
        cursor: default;
        transition: all 0.1s ease-out;
    }

    .avatars-group__item.more {
        align-items: center;
        display: flex;
    }

    .avatars-group__item.more:hover {
        transform: none;
    }

    .avatars-group__item:hover {
        transform: translateY(-4px);
        z-index: 1;
    }

    .avatars-group .v-avatar {
        box-shadow: 0px 0px 0px 2px #fff inset;
    }

    .avatars-group .v-avatar img {
        padding: 2px;
    }

    .avatars-group .v-avatar span {
        align-items: center;
        display: flex;
        font-size: 110%;
        font-weight: 700;
        height: 100%;
        justify-content: center;
        letter-spacing: 0.1rem;
        text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.56);
        width: inherit;
    }

    .v-avatar.bordered {
        box-shadow: 0px 0px 0px 2px #fff inset;
    }

    .v-avatar.bordered img {
        padding: 2px;
    }

    .v-avatar.bordered.small {
        box-shadow: 0px 0px 0px 1px #fff inset;
    }

    .v-avatar.bordered.small img {
        padding: 1px;
    }

</style>
